import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-foreground-600 text-xs font-medium mb-4">
            全部分类
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            探索八卦世界
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大分类覆盖娱乐圈全貌，从明星绯闻到社会热点，你想吃的瓜这里都有
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colorClasses: Record<string, { bg: string; text: string }> = {
              primary: { bg: 'bg-primary-100', text: 'text-primary-500' },
              accent: { bg: 'bg-accent-100', text: 'text-accent-500' },
              secondary: { bg: 'bg-secondary-100', text: 'text-secondary-500' },
            };
            const colors = colorClasses[cat.color] || colorClasses.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group relative bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300"
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${colors.bg} ${colors.text} group-hover:bg-white/20 group-hover:text-white transition-all duration-300 mb-4`}>
                  <i className={`${cat.icon} text-lg md:text-xl`} />
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-white transition-colors mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 group-hover:text-white/80 transition-colors leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-3 text-xs text-foreground-400 group-hover:text-white/70 transition-colors">
                  {cat.articleCount} 篇爆料
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}